import React, { ReactNode } from 'react'

interface ContentLayoutContextType {
  setContainerTitle: (title?: string | ReactNode) => void
  setContainerActions: (actions?: any[]) => void
  setContainerStatus: (status?: string) => void
}

const initialValues: ContentLayoutContextType = {
  setContainerTitle: () => {},
  setContainerActions: () => {},
  setContainerStatus: () => {},
}

const ContentLayoutContext = React.createContext<ContentLayoutContextType>(initialValues)

export default ContentLayoutContext
